import { get } from "../GenericServices";

const RDA = {
  getDetail: (projectTaskId, querystring) => {
    return get(`rda/detail/${projectTaskId}?${querystring}`);
  },
  getDetailByServiceId: (projectId, projectTaskId, serviceId, querystring) => {
    return get(`rda/detail/${projectId}/${projectTaskId}/${serviceId}?${querystring}`);
  },
};

export default RDA;
